import React from "react";
import {observer} from "mobx-react";
import {useViewController} from "data/services/locator";
import {Bindings} from "data/constants/bindings";
import {type IBackdoorController} from "views/pages/backdoor/backdoor.controller";
import styled from "@emotion/styled";
import logo from "assets/img/logo.svg";

const BackDoorPageWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-flow: column;
	padding: 20px;

	img {
		margin-bottom: 30px;
	}
`;

const Input = styled.input`
	height: 40px;
	border-radius: 20px;
	padding: 0 10px;
	margin-bottom: 20px;
	min-width: 300px;

	&:focus {
		box-shadow: 0 0 3px 3px rgba(0, 200, 0, 1);
	}
`;

const Form = styled.form`
	display: flex;
	flex-flow: column;
	align-items: center;
	justify-content: center;

	button {
		width: 100%;
		height: 40px;
		border-radius: 20px;
		background: rgba(0, 200, 0, 1);
		box-shadow: none;
		border: none;
	}
`;

export const BackdoorPage: React.FC = observer(() => {
	const {onSubmit} = useViewController<IBackdoorController>(Bindings.BackdoorController);

	return (
		<BackDoorPageWrapper>
			<img src={logo} alt="The main logo of MLB" />

			<Form onSubmit={onSubmit}>
				<Input name="email" type="email" placeholder="Please enter you email" />
				<button type="submit">Go</button>
			</Form>
		</BackDoorPageWrapper>
	);
});

export default BackdoorPage;
